import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import { numberWithCommas } from 'helper';
import * as actions from '../actions';
import * as c from '../constant';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';
import ViewModal from '../modals/ViewModal';
import TransferModal from '../modals/TransferModal';

const form = {
  keyword: '',
};

function TaxCreditContainer({
  history,
  getTaxCreditList,
  taxCreditList,
  taxCreditListPager,
  isLoading,
  removeTaxCredit,
}) {
  const [formData, setFormData] = useState(form);
  const [pageFilterData, setFilterPageData] = useState({
    is_paginated: 1,
    isPaginate: 1,
  });
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePage = (page) => {
    setFilterPageData({ ...pageFilterData, page });
    getTaxCreditList({ ...pageFilterData, page });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data} id={data.id} />,
      title: 'Update Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleViewModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewModal updateList={data} id={data.id} handleEdit={handleEdit} />
      ),
      title: 'View',
      modalSize: 'modal-xl',
    });
  };

  const handleTransfer = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransferModal id={data.id} />,
      title: 'Transfer Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (id) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this item?',
      () => {
        removeTaxCredit(id, {}, () => {
          getTaxCreditList({}, () => {
            history.push('/rpt/building/settings/tax-credit');
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getTaxCreditList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getTaxCreditList({
        is_paginated: 1,
        q: formData.keyword,
        sort_by: 'asc',
      });
    } else {
      setFormData([]);
      history.replace({ pathname: window.location.pathname });
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="mr-5 mt-5">
      <div className="shadow card-content-listing bg-white rounded mh-100">
        <div className="d-flex pr-5 pb-4">
          <div className="list-name">Tax Credit</div>
          <div className="my-auto ml-auto">
            {Acl(permissions, ['E2E RPT BUILDING ADD TAX CREDIT']) && (
              <button
                type="button"
                onClick={handleAddModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
              >
                <i className="fas fa-plus" />
                &nbsp; Add Tax Credit
              </button>
            )}
          </div>
        </div>
        <div className="pr-5">
          <div className="d-flex flex-column pl-4 pb-4">
            <div className="col-12 form-wrapper d-flex align-items-center search-container">
              <span className="icon">
                <i className="fa fa-lg fa-search" />
              </span>
              <input
                className="search-input w-100"
                type="text"
                name="keyword"
                id="keyword"
                placeholder="Search..."
                onChange={handleOnChange}
                value={_.get(formData, 'keyword') || ''}
                maxLength={50}
              />
            </div>
          </div>
        </div>
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div className="pl-4 pr-5">
            <table className="table table-striped table-sm">
              <thead className="table-header">
                <tr className="bg-primary-light">
                  <td className="h3 pl-3" width="500">
                    PIN
                  </td>
                  <td className="h3" width="500">
                    TDN
                  </td>
                  <td className="h3" width="500">
                    Amount
                  </td>
                  <td />
                </tr>
              </thead>
              <tbody className="table-details text-dark">
                {taxCreditList.length !== 0 ? (
                  taxCreditList.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td className="pl-3 justify-center">
                          {_.get(item, 'attributes.building_application_pin') ||
                            '---'}
                        </td>
                        <td>
                          {_.get(item, 'attributes.building_application_tdn') ||
                            '---'}
                        </td>
                        <td>
                          <span className="font-weight-bold">PHP </span>
                          {numberWithCommas(_.get(item, 'attributes.amount')) ||
                            '---'}
                        </td>
                        <td>
                          <div className="d-flex justify-content-end">
                            {Acl(permissions, [
                              'E2E RPT LAND VIEW TAX CREDIT',
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleViewModal({
                                  id: _.get(item, 'id'),
                                  name: _.get(item, 'attributes.name'),
                                  admin_module_id: _.get(
                                    item,
                                    'attributes.admin_module_id'
                                  ),
                                })}
                              >
                                <i className="far fa-eye icon-plain-square shadow-sm" />
                              </button>
                            )}
                            {Acl(permissions, [
                              'E2E RPT BUILDING EDIT TAX CREDIT',
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleEdit({
                                  id: _.get(item, 'id'),
                                  name: _.get(item, 'attributes.name'),
                                  admin_module_id: _.get(
                                    item,
                                    'attributes.admin_module_id'
                                  ),
                                })}
                              >
                                <i className="fas fa-edit icon-plain-square shadow-sm" />
                              </button>
                            )}
                            {Acl(permissions, [
                              'E2E RPT BUILDING TRANSFER TAX CREDIT',
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleTransfer({
                                  id: _.get(item, 'id'),
                                  name: _.get(item, 'attributes.name'),
                                  admin_module_id: _.get(
                                    item,
                                    'attributes.admin_module_id'
                                  ),
                                })}
                              >
                                <i className="fa fa-external-link-alt icon-plain-square shadow-sm" />
                              </button>
                            )}
                            {Acl(permissions, [
                              'E2E RPT BUILDING DELETE TAX CREDIT',
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleRemove(_.get(item, 'id'))}
                              >
                                <i className="far fa-trash-alt icon-delete-square shadow-sm" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No Results Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        <div className="list-pagination">
          {taxCreditListPager.total_pages > 1 ? (
            <div className="d-flex justify-content-center text-center align-item-center">
              <Pagination
                data={taxCreditListPager}
                onChange={handleChangePage}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}

TaxCreditContainer.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  getTaxCreditList: PropTypes.instanceOf(Function).isRequired,
  taxCreditList: PropTypes.instanceOf(Array).isRequired,
  taxCreditListPager: PropTypes.instanceOf(Object).isRequired,
  removeTaxCredit: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxCreditList: _.get(api, `${c.GET_TAX_CREDIT}.list`) || [],
  taxCreditListPager: _.get(api, `${c.GET_TAX_CREDIT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxCreditContainer);
